<template>
  <div>
    <AboutBanner :content="banners.find(item=>item.id === 103).details"
                 :title="banners.find(item=>item.id === 103).title"
                 :img="banners.find(item=>item.id === 103).photo_file"/>
    <div class="mt-16" style="background: rgba(232,232,232,0.12)">
      <AboutTitle title="پروژه ها" page-route="/sub/glass/projects"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in projects.topics" :key="i" cols="12">
            <BlockNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import AboutTitle from "../../About/Components/AboutTitle";
import BlockNewsItem from "../components/GlassNewsItem";
import {mapState} from "vuex";
import AboutBanner from "../../About/Components/AboutBanner";
export default {
  name: 'BlockProjects',
  components: {AboutBanner, BlockNewsItem, AboutTitle},

  created() {
    if (this.banners==null){
      this.$store.dispatch('glassManagement/getGlassBanners');
    }
    this.$store.dispatch('glassManagement/getGlassProjects');
  },
  computed:{
    ...mapState({
      projects:state => state.glassManagement.glassProjects,
      banners: state => state.glassManagement.glassBanners,
    })
  }
}
</script>
